import { DictionaryTerritorialTechnicalUnitAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useTerritorialTechnicalUnits() {
  return useAutocompleteSource<DictionaryTerritorialTechnicalUnitAutocomplete>({
    url: EvidenceAPI.DICTIONARY_TERRITORIAL_TECHNICAL_UNITS + '/autocomplete',
  });
}
